export default __webpack_public_path__ + "static/media/king size bedroom.82a1311c.svg";